var map = {
	"./autoplay/lg-autoplay.umd.js": [
		"./node_modules/lightgallery/plugins/autoplay/lg-autoplay.umd.js",
		"vendors-node_modules_lightgallery_plugins_autoplay_lg-autoplay_umd_js"
	],
	"./comment/lg-comment.umd.js": [
		"./node_modules/lightgallery/plugins/comment/lg-comment.umd.js",
		"node_modules_lightgallery_plugins_comment_lg-comment_umd_js"
	],
	"./fullscreen/lg-fullscreen.umd.js": [
		"./node_modules/lightgallery/plugins/fullscreen/lg-fullscreen.umd.js",
		"node_modules_lightgallery_plugins_fullscreen_lg-fullscreen_umd_js"
	],
	"./hash/lg-hash.umd.js": [
		"./node_modules/lightgallery/plugins/hash/lg-hash.umd.js",
		"node_modules_lightgallery_plugins_hash_lg-hash_umd_js"
	],
	"./mediumZoom/lg-medium-zoom.umd.js": [
		"./node_modules/lightgallery/plugins/mediumZoom/lg-medium-zoom.umd.js",
		"node_modules_lightgallery_plugins_mediumZoom_lg-medium-zoom_umd_js"
	],
	"./pager/lg-pager.umd.js": [
		"./node_modules/lightgallery/plugins/pager/lg-pager.umd.js",
		"node_modules_lightgallery_plugins_pager_lg-pager_umd_js"
	],
	"./relativeCaption/lg-relative-caption.umd.js": [
		"./node_modules/lightgallery/plugins/relativeCaption/lg-relative-caption.umd.js",
		"node_modules_lightgallery_plugins_relativeCaption_lg-relative-caption_umd_js"
	],
	"./rotate/lg-rotate.umd.js": [
		"./node_modules/lightgallery/plugins/rotate/lg-rotate.umd.js",
		"vendors-node_modules_lightgallery_plugins_rotate_lg-rotate_umd_js"
	],
	"./share/lg-share.umd.js": [
		"./node_modules/lightgallery/plugins/share/lg-share.umd.js",
		"node_modules_lightgallery_plugins_share_lg-share_umd_js"
	],
	"./thumbnail/lg-thumbnail.umd.js": [
		"./node_modules/lightgallery/plugins/thumbnail/lg-thumbnail.umd.js",
		"vendors-node_modules_lightgallery_plugins_thumbnail_lg-thumbnail_umd_js"
	],
	"./video/lg-video.umd.js": [
		"./node_modules/lightgallery/plugins/video/lg-video.umd.js",
		"vendors-node_modules_lightgallery_plugins_video_lg-video_umd_js"
	],
	"./vimeoThumbnail/lg-vimeo-thumbnail.umd.js": [
		"./node_modules/lightgallery/plugins/vimeoThumbnail/lg-vimeo-thumbnail.umd.js",
		"node_modules_lightgallery_plugins_vimeoThumbnail_lg-vimeo-thumbnail_umd_js"
	],
	"./zoom/lg-zoom.umd.js": [
		"./node_modules/lightgallery/plugins/zoom/lg-zoom.umd.js",
		"vendors-node_modules_lightgallery_plugins_zoom_lg-zoom_umd_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./node_modules/lightgallery/plugins lazy recursive ^\\.\\/.*\\.umd\\.js$";
module.exports = webpackAsyncContext;